import { NgModule } from '@angular/core';
import { RouterModule, Routes, TitleStrategy } from '@angular/router';
import { provideAWFAngularRoutes } from '@ansys-internal/awf-angular/providers';
import { Title } from '@angular/platform-browser';
import { AwfTitleStrategy } from '@ansys-internal/awf-angular/shared';
import { WorkspacePage } from './awf-contributions/pages/workspace/workspace.page';

export const routes: Routes = [...provideAWFAngularRoutes([WorkspacePage])];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
  providers: [Title, { provide: TitleStrategy, useClass: AwfTitleStrategy }],
})
export class AppRoutingModule {}
